import { NgModule } from '@angular/core';
import { DmsPipe } from './dms.pipe';
import { FieldAliasPipe } from './field-alias.pipe';
import { FilterOperatorPipe } from './filter-operator.pipe';
import { FormatNumberPipe } from './format-number.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { SearchListPipe } from './search-list.pipe';
import { FieldFormatPipe } from './field-format.pipe';

const pipes = [
  FormatNumberPipe,
  DmsPipe,
  FilterOperatorPipe,
  SafeUrlPipe,
  SearchListPipe,
  FieldAliasPipe,
  FieldFormatPipe
];

@NgModule({
  declarations: pipes,
  exports: pipes,
})
export class PipesModule {}
